import React from 'react';
import SectionLayout from 'atoms/Layout/Section/SectionLayout';
import SellingRightNowImageAndContent from 'organisms/Homepage/SellingRightNowImageAndContent/SellingRightNowImageAndContent';

const SellingRightNow = (): JSX.Element => (
  <SectionLayout
    padding={['spacing-7xl', 'spacing-4xl']}
    paddingSm={['spacing-4xl', 'spacing-xl']}
    maxWidth='width-3xl'
    background='bg-tertiary'
  >
    <SellingRightNowImageAndContent />
  </SectionLayout>
);

export default SellingRightNow;
